export default __webpack_public_path__ + "static/media/placeholder_dummy2016-coach02-de.5f731393.png";